<template>
	<div class="detail-view dining">
		<dinning-area-page></dinning-area-page>
	</div>
</template>

<script>
import DinningAreaPage from "../components/pages/DiningAreaPage";
export default {
  name: "DiningArea",
  components: {DinningAreaPage},
}
</script>


<style lang="scss">
.detail-view {
	&.dining {
		.product-detail {
			// top: 12vh;
		}
	}
}
</style>
